module.exports = __webpack_public_path__ + "static/media/bonarka14.33338b18.jpg";